
export const ModuleCustomSettings = {
    moduleName: "",
    folderName: "",
    category: "",
    businessController: "",
    dependencies: "",
    hostPermissions: "",
    portable: false,
    searchable: false,
    shareable: 2,
    upgradeable: false,
    premiumModule: false
};

export const CoreLanguagePack = {
    languageId: 1
};

export const ExtensionLanguagePack = {
    dependentPackageId: 1
};